import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react'

import { buttonClasses, type ButtonVariant } from './buttonClasses'

interface CommonProps {
  /** Color role. Defaults to `primary` (glowing CTA). */
  variant?: ButtonVariant
  className?: string
}

type AsLink = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }
type AsButton = ButtonHTMLAttributes<HTMLButtonElement> & { href?: never }

export type ButtonProps = CommonProps & (AsLink | AsButton)

/**
 * The RuneLedger CTA: Cinzel uppercase over the arcane gradient (primary) or a quiet outline
 * (ghost). Renders an `<a>` when `href` is given, a `<button>` otherwise. For internal SPA
 * navigation prefer a router `<Link>` styled with {@link buttonClasses}.
 */
export function Button({ variant = 'primary', className, children, ...rest }: ButtonProps) {
  const classes = buttonClasses(variant, className)
  if (rest.href !== undefined) {
    return (
      <a {...rest} className={classes}>
        {children}
      </a>
    )
  }
  return (
    <button type="button" {...rest} className={classes}>
      {children}
    </button>
  )
}
